import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import helpIcon from '../atoms/data/help-icon.svg';
import { TRAINING_NAME } from '../../common/constants.js';

const HeaderTop = (props) => {
    return(
        <Body>
            <Button onClick={props.onClickBackHome}>
                ＜
            </Button>
            {TRAINING_NAME[0]}
            <HelpButton onClick={props.onClickHelp}>
                <img src={helpIcon} alt="img" width="32px" height="32px" />
            </HelpButton>
        </Body>
    );
}

export { HeaderTop };

HeaderTop.propTypes = {
    onClickBackHome: PropTypes.func.isRequired,
    onClickHelp: PropTypes.func.isRequired,
};

const Body = styled.div`
    width: 100%;
    height: 64px;

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.2);
    position: relative;
    z-index: 2;
    background-color: #F2F2F2;
`;

const Button = styled.div`
    margin: 0 10px;
    color: #00b050;
    font-size: 30px;
`;

const HelpButton = styled.span`
    margin: 0 5px;
    color: #F6D47E;
`;
